<template>
  <section class="rates" :class="{ hide_private_tour_rate: rate.IsPrivateTourRate }" v-show="showThisRate && !hideDurationRate">
    <h3>{{ rate.Name }}</h3>
    <img
      v-if="rate.PhotoVersion"
      :src="rate.PhotoDomain + 'w_100,h_100,c_fill/v' + rate.PhotoVersion + rate.PhotoFolder + '/original'"
      width="100px"
      height="100px"
      @click.prevent="showImage(true)"
    />
    <div class="lightbox" v-if="showModal" @click.prevent="showImage(false)">
      <img v-if="rate.PhotoVersion" :src="rate.PhotoDomain + 'w_500/v' + rate.PhotoVersion + rate.PhotoFolder + '/original'" width="500px" />
    </div>
    <small v-if="(!isPrivateTour || rate.SetPrivateTourPrice) && !rate.HideRateDiscountFromCustomer" style="margin-top: -7px" class="text-blue"
      >From
      <currency :class="{ strikethrough: rate.PackageDiscount }" :value="rate.Price" />
      <currency style="padding-left: 5px;" v-if="rate.PackageDiscount" :value="rate.Price - rate.PackageDiscount" />
    </small>
    <p style="margin-top: 0px;">{{ rate.Description }}</p>

    <pre>showThisRate: {{ showThisRate }}</pre>
    <pre>disableAdd: {{ disableAdd }}</pre>
    <pre>packageParticipants: {{ packageParticipants }}</pre>
    <pre>rate.Participants: {{ rate.Participants }}</pre>
    <pre>ultimateMaxPeople: {{ ultimateMaxPeople }}</pre>
    <pre>OrderEntityTimeRateGUID: {{ rate.OrderEntityTimeRateGUID }}</pre>
    <pre>Vacancies: {{ rate.Vacancies }}</pre>
    <!-- <pre> Rate: {{rate}} </pre> -->
    <pre>{{ myMin }} / {{ myMax }}</pre>
    <number-ticker
      :disableAdd="disableAdd || disableDurationAdd || rate.Participants >= myMax"
      :disableAllAdds="disableAllAdds"
      :max="myMax"
      :min="rate.IsRequired ? myMin : 0"
      :errorOverride="rate.Participants < myMin"
      v-model="participants"
    />
    <div class="number_ticker_feedback">
      <transition name="slide-vertical">
        <p
          v-if="rate.Participants < myMin"
          class="-text-red"
          :class="{
            'text-red': rate.IsRequired,
          }"
        >
          <small>Minimum of {{ myMin }} required</small>
        </p>
      </transition>

      <transition name="slide-vertical">
        <p v-if="rate.Participants == myMax">
          <small>No more than {{ myMax }} allowed</small>
        </p>
      </transition>
    </div>
  </section>
</template>

<script>
import NumberTicker from "../components/NumberTicker.vue";

export default {
  name: "GuestsRate",
  props: ["activity", "rate", "disableAdd", "isPrivateTour", "isPackage", "packageParticipants", "ultimateMaxPeople", "totalActivityParticipants"],
  data: function() {
    return {
      hideDurationRate: false,
      showModal: false,
    };
  },
  activated() {
    this.rateParticipants = this.rate.Participants;
  },
  created() {
    this.hideDurationRate = this.isDurationRate ? this.rate.InternalUseOnly || (this.rate.Vacancies == 0 && !this.rate.Participants) : false;
  },
  components: {
    NumberTicker,
  },
  methods: {
    showImage(value) {
      this.showModal = value;
    },
  },
  computed: {
    disableAllAdds() {
      if (this.totalActivityParticipants >= this.ultimateMaxPeople) {
        return true;
      }
      return false;
    },
    disableDurationAdd() {
      if (this.isDurationRate) {
        return this.rate.Vacancies == 0;
      }
      return false;
    },
    myMax() {
      var max = this.rate.MaxParticipants ? this.rate.MaxParticipants : 99999999;
      return max;
      // var max = this.rate.MaxParticipants
      // 	? this.rate.MaxParticipants
      // 	: 99999999;
      // return this.rate.Vacancies ? Math.min(max, this.rate.Vacancies) : max;
    },
    myMin() {
      var isPrivate = this.isPrivateTour;
      var participants = this.rate.Participants;
      var min = this.rate.MinForPrivateTourOnly ? (isPrivate ? this.rate.MinParticipants : false) : this.rate.MinParticipants;
      if (this.rate.IsRequired) {
        return min ? min : 1;
      }
      return participants > 0 ? (min ? min : 0) : 0;
    },
    showThisRate() {
      if (!this.isPrivateTour && this.rate.IsForPrivateToursOnly) if (this.isPrivateTour) return true;
      if (this.rate.InternalUseOnly === true) {
        return false;
      }
      if (!this.isPackage) {
        return true;
      }
      // Package
      else {
        if ((!this.rate.MinForPrivateTourOnly || this.isPrivateTour) && this.rate.MinParticipants * 1 > 0) {
          if (this.rate.MinParticipants > this.packageParticipants) {
            return false;
          }
        }
      }

      return true;
    },
    isDurationRate() {
      return this.activity.CapacityTypeKey == 2 && this.rate.Duration && this.rate.Vacancies != null;
    },
    participants: {
      get: function() {
        return this.rate.Participants;
      },
      set: function(val) {
        this.rate.Participants = val;

        if (this.isDurationRate) {
          this.$emit("onDurationVacancyUpdate", this.rate);
        }
      },
    },
  },
};
</script>

<style scoped>
img {
  display: block;
  cursor: pointer;
}
.lightbox {
  background-color: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 10000;
}
.lightbox img {
  position: relative;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
  top: 50%;
  left: 50%;
  margin-left: -250px;
  margin-top: -200px;
}
@media (max-width: 600px) {
  .lightbox img {
    width: 250px;
    margin-left: -125px;
  }
}
</style>
